import AlertIcon from "@assets/icons/alert-icon.svg";

import { BackgroundSection } from "@components/Sections";
import { Paragraph } from "@ui/Content";
import { H3 } from "@ui/Headings";
import { MainLogo } from "@ui/Logos/MainLogo";
import { Button } from "@ui/Button";
import { GOOGLE_ACCOUNT_CHOOSER_URL, GOOGLE_MAIL_DOMAIN, HTTPS_PROTOCOL } from "@config/constants";
import { GrantProvider } from "@app-types/common.type";
import { useGetUser } from "@screens/connect-meridian/hooks/useGetUser";
import { useMemo } from "react";

const switchAccount = () => {
  const url = GOOGLE_ACCOUNT_CHOOSER_URL + encodeURIComponent(HTTPS_PROTOCOL + GOOGLE_MAIL_DOMAIN);
  window.open(url, "", "noopener,noreferrer");
};

export default function EmailMismatchScreen() {
  const { data: user } = useGetUser(false);

  const googleGrantEmail = useMemo(() => {
    const googleGrant = user?.grants?.find((grant) => grant.provider === GrantProvider.GOOGLE);
    return googleGrant?.username ?? null;
  }, [user?.grants]);
  
  return (
    <div className="flex flex-col">
      <div className="flex flex-col justify-center items-center pt-[64px]">
        <MainLogo className="pb-[50px]" />

        <BackgroundSection
          className={"bg-yellow-100"}
          icon={<AlertIcon className="text-yellow-500" />}
        />

        <H3 className="pt-5 text-gray-600 dark:text-invertedPrimary80">Wrong Gmail account</H3>

        <div className="flex flex-col gap-4 pt-[32px] pb-6 px-8">
          <Paragraph>
            Meridian works only with the mail account you connected in your profile.
          </Paragraph>

          <Paragraph className="text-center text-gray-800 dark:text-invertedPrimary80">
            <strong className="block">Connected Google account:</strong>
            <span className="block mt-2 leading-tight whitespace-nowrap">
              {googleGrantEmail || "(Not connected)"}
            </span>
          </Paragraph>

          {googleGrantEmail && <Button buttonType={"PRIMARY"} onClick={switchAccount} className="min-w-[270px] mt-5">
            Switch account
          </Button>}
        </div>
      </div>
    </div>
  );
}
